import React from 'react';
import FilteredAppPageAbstract from '../../Lib/Components/FilteredAppPageAbstract';
import ChildrenList from '../FilteredLists/ChildrenList';

class ChildrenListAppPage extends FilteredAppPageAbstract {
	render()
	{
		const { history } = this.props;

		return super.render(
			<ChildrenList history={history}/>
		);
	}
}

export default ChildrenListAppPage;
